import {defineMessages} from "react-intl";

const messages = defineMessages({
    yes:{
	id:"app.admin-status-update-confirm-modal.yes",
	description:"yes",
	defaultMessage:"Yes"
    },
    
    no:{
	id:"app.admin-status-update-confirm-modal.no",
	description:"no",
	defaultMessage:"No"
    },

    statusUpdate:{
	id:"app.admin-status-update-confirm-modal.status",
	description:"Update Status",
	defaultMessage:"Update Status"
    },

    confirmationMsg:{
	id:"app.admin-status-update-confirm-modal.confirm",
	description:"confirm",
	defaultMessage:"Are you sure you want to update product status?"
    }
});

export default messages;
